import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectComposedReportFYear = createSelector(
  [selectComposedReportState],
  ({ fYear }) => fYear
)
